import { render, staticRenderFns } from "./HomeLawMasterRealFollowUp.vue?vue&type=template&id=1f0b2818&scoped=true"
import script from "./HomeLawMasterRealFollowUp.vue?vue&type=script&lang=js"
export * from "./HomeLawMasterRealFollowUp.vue?vue&type=script&lang=js"
import style0 from "./HomeLawMasterRealFollowUp.vue?vue&type=style&index=0&id=1f0b2818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b2818",
  null
  
)

export default component.exports